import { render, staticRenderFns } from "./storeOrderManage.vue?vue&type=template&id=55c5f357&scoped=true"
import script from "./storeOrderManage.vue?vue&type=script&lang=js"
export * from "./storeOrderManage.vue?vue&type=script&lang=js"
import style0 from "./storeOrderManage.vue?vue&type=style&index=0&id=55c5f357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5f357",
  null
  
)

export default component.exports